const INFO = {
	main: {
		title: "Online Portfolio",
		name: "Aaron Kim",
		email: "akim.jinsoo@gmail.com",
 		logo: "../logo.png", //TODO change logo to my logo
		universityLogo: "../ut-logo.png",
	},

	socials: {
		github: "https://github.com/akim-jinsoo",
		linkedin: "https://www.linkedin.com/in/akim-jinsoo/",
	},

	homepage: {
		title: "Hello! I'm Aaron",
		description:
			"A PhD student in Mechanical Engineering at UT Austin, specializing in mechanical design, robotic manipulation, and machine learning.",
	},

	// About section (editable content for the homepage About card)
	about: {
		paragraphs: [
			"I'm a 3rd year graduate student, pursuing my PhD in Mechanical Engineering at The University of Texas at Austin, specializing in dynamic systems and control. My research experience comes primarily from working with Dr. Luis Sentis at the Human-Centered Robotics Lab, where I focus on robotic hand design and contact-rich manipulation.",
			"Outside of robotics, I enjoy cooking, cars (working on them and driving them), traveling, photography, and climbing.",
			"Feel free to reach out via LinkedIn or email; I’m always open to connecting about research or industry collaborations."
		],
	},

	education: [
		{
			degree: "Ph.D. in Mechanical Engineering",
			institution: "The University of Texas at Austin",
			period: "May 2026 - Present",
		},
		{
			degree: "M.S. in Mechanical Engineering",
			institution: "The University of Texas at Austin",
			period: "August 2024 - May 2026",
			gpa: "3.8/4.0",
			description: "Relevant Coursework: Sensor-based algorithms, Robot Manipulation Learning, Modern Control, Learning for dynamics and control",
			awards: [
				"Award: NSF Research Traineeship Recipient"
			],
		},
		{
			degree: "B.S. in Mechanical Engineering",
			institution: "The University of Texas at Austin",
			period: "August 2020 - May 2024",
			gpa: "3.6/4.0",
			description: "Relevant Coursework: Design of Human-centered Robotics, Robot Mechanism Design, Mechatronics, Dynamics Systems & Control",
		},
	],


	projects: [
		{
			title: "ARISTO Hand",
			slug: "aristo",
			description:
				"3 Fingered Robotics Hand inspired by human-like sensing.",
			logo: "./aristo.png",
			longMarkupKey: "aristo",
			category: "research",
		},

		{
			title: "PLATO Hand",
			slug: "plato",
			description:
				"3 Fingered Robotics Hand inspired by human musculoskeletal autonomy.",
			logo: "./plato.png",
			longMarkupPath: "/projects/plato.txt",
			longMarkupKey: "plato",
			category: "research",
		},

		{
			title: "Isaac Lab: Reinforcement Learning for Robotic Manipulation",
			slug: "reinforcement-learning",
			description:
				"Utilizing Isaac Lab for simulating and training PLATO/ARISTO Hand for manipulation tasks.",
			logo: "./rl.gif",
			longMarkupKey: "rl",
			category: "research",
		},

		{
			title: "Hand Designs",
			slug: "hand-designs",
			description:
				"Unrealized hand design concepts and iterations.",
			logo: "./hand-design/aristo-apple.png",
			longMarkupKey: "handDesigns",
			category: "research",
		},

		{
			title: "Imitation Learning for Robotic Manipulation",
			slug: "imitation-learning",
			hidden: true,
			description:
				"Utilizing ARISTO Hand has data collection platform for imitation learning in robotic manipulation tasks and deployed policies on ARISTO Hand",
			// logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			longMarkupKey: "il",
			longDescription: "!!!This page is under construction!!! Please check back later for updates.",
			category: "research",
		},

		{
			title: "Sony: Robotic Hand",
			slug: "sony-robotic-hand",
			description:
				"Developed and tested actuators and 3-finger robotic hand at the Fundamental Robotics Lab in Sony, Tokyo, Japan.",
			logo: "./hand.png",
			longMarkupKey: "sony",
			category: "internship",
		},

		{
			title: "Human Centered Robotics Lab: Undergraduate Research",
			slug: "hcrl-ugrad-research",
			description:
				"Undergraduate researcher on humanoids and assistive robotics at the Human Centered Robotics Lab.",
			logo: "./draco.png",
			longMarkupKey: "hcrl",
			category: "research",
		},

		{
			title: "Samsung Austin Semiconductor",
			slug: "sas",
			description:
				"Internship at Samsung Austin Semiconductor.",
			logo: "./fab.png",
			longMarkupKey: "samsung",
			category: "internship",
		},

		{
			title: "Human-Enabled Robotics Technology Lab: Haptic Mouse Device",
			slug: "hero",
			description:
				"An autonomous multi-channel system that automates tactile sensitivity testing in mice to support neurological pain research.",
			logo: "./mouse.png",
			longMarkupKey: "hero",
			category: "research",
		},


		{
			title: "Freshman Introduction to Research in Engineering",
			slug: "fri",
			description:
				"Developed and lead a rehabilitation device for children with traumatic brain injuries.",
			logo: "./fire.png",
			longMarkupKey: "fire",
			category: "research",
		},

		{
			title: "Low-cost, Single-Actuator Anthropomorphic Hand",
			slug: "low-cost-single-actuator-anthropomorphic-hand",
			description:
				"ME 380R",
			logo: "./low-cost-hand/minimal-hand.jpeg",
			longMarkupKey: "lowCostAnthroHand",
			category: "course",
		},

		{
			title: "Hockey Bot",
			slug: "hockey-bot",
			description:
				"ME 392Q",
			logo: "./hockey.png",
			longMarkupKey: "hockey",
			category: "course",
		},

		{
			title: "Battle Bot",
			slug: "battle-bot",
			description:
				"ME 366J",
			logo: "./battle.png",
			longMarkupKey: "battle",
			category: "course",
		},

		{
			title: "RC Car",
			slug: "rc-car",
			description:
				"ME 388",
			logo: "./car.png",
			longMarkupKey: "car",
			category: "course",
		},

	],

	// Publications: add/remove entries here to show on the Publications page
	publications: [
		{
			id: "paper-2",
			title: "ARISTO Hand: Sensing-Driven Distal Hyperextension for Fine-Grained Manipulation",
			authorsList: [
				{ name: "Aaron Kim", highlight: true },
				{ name: "Dong Ho Kang" },
				{ name: "Mark Helwig" },
				{ name: "Mingyo Seo" },
				{ name: "Kazuto Yokoyama" },
				{ name: "Tetsuya Narita" },
				{ name: "Luis Sentis" },
			],
			venue: "IEEE/ASME International Conference on Advanced Intelligent Mechatronics",
			year: 2026,
			links: [
				{ href: "https://arxiv.org/pdf/2605.30508", label: "arXiv" },
				{ href: "https://aristohand.github.io/", label: "Website" },
			],
		},
		{
			id: "paper-1",
			title: "PLATO Hand: Shaping Contact Behavior with Fingernails for Precise Manipulation",
			authorsList: [
				{ name: "Dong Ho Kang" },
				{ name: "Aaron Kim", highlight: true },
				{ name: "Mingyo Seo" },
				{ name: "Kazuto Yokoyama" },
				{ name: "Tetsuya Narita" },
				{ name: "Luis Sentis" },
			],
			venue: "IEEE Robotics and Automation Letters",
			year: 2026,
			links: [
				{ href: "https://arxiv.org/pdf/2602.05156", label: "arXiv" },
				{ href: "https://platohand.github.io/", label: "Website" },
			],
			abstract:
				"We present the PLATO Hand, with a hybrid fingernail and pulp fingertip and guided contact modeling that enable stable, force-observable, edge-sensitive manipulation across diverse objects.",
		},
		// examples of links
			// link: "https://github.com",

			// link: ["https://github.com", "PDF"],
		
			// links: [
			// { href: "https://github.com", label: "PDF" },
			// { href: "https://arxiv.org/abs/...", label: "arXiv" }
			// ],

	],
};

export default INFO;
